import React from "react"

export default class OrderModel {
  constructor( data ) {
    Object.assign( this, data )
    this._model = "OrderModel"
    
    this.nettoBackorder = 0
    this.countBackorder = 0
    
    if ( this.positions ) {
      this.positions.forEach( pos => {
        this.countbackorder += (pos.open || 0)
        this.nettoBackorder += (pos.open * pos.price)
      } )
    }
  }
  
}




// WEBPACK FOOTER //
// ./src/shop/OrderModel.js